$(function(){
    $('#toggleSearch').on('click', function(){
        $('body').toggleClass('search-desktop-is-active');
        if ($('body').hasClass('search-desktop-is-active')) {
            $('#searchDesktopInput').focus();
        }
        $('#searchDesktopInput').on('focusout', function () {
            $('body').removeClass('search-desktop-is-active');
        });
    });

});



// WEBPACK FOOTER //
// ./resources/js/components/search.js